module.exports = __webpack_public_path__ + "img/android.19ec2b3a.png";